import React, { useState } from "react";
import Modal from "sushiweb/Modal";
import TableFields from "../../../constants/LifeLine/ActionHistoryTableFields.json";
import { isEmpty, isValNull } from "../../../utils";
import styled from "styled-components";
import Table from "../../Common/Table";
import { AddEdit } from "sushiweb/Icons";

const ActionHistoryModal = (props) => {
  const { data } = props;
  const [showModal, setShowModal] = useState(false);

  const getFieldValue = (obj, key) => {
    if (isValNull(obj[key])) {
      return "N/A";
    }
    return obj[key];
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const handleDoClick = () => {
    if (isEmpty(data)) {
      return;
    }
    setShowModal(true);
  };

  return [
    <ActionHistoryContainer>
      <ActionHistoryStyle onClick={handleDoClick}>
        <AddEdit size="1rem"></AddEdit>
        <b> Action History </b>
      </ActionHistoryStyle>
    </ActionHistoryContainer>,
    <>
      {showModal && (
        <Modal
          visible={showModal}
          onClose={handleClose}
          type="medium"
          showCloseIcon={true}
          slideOnMobile
          isCentered
          padding="2rem"
          preventFocus
        >
          {
            <Table
              list={data}
              getFieldValue={getFieldValue}
              fields={TableFields}
            />
          }
        </Modal>
      )}
    </>,
  ];
};

const ActionHistoryStyle = styled.div`
  display: flex;
  cursor: pointer;
  b {
    padding-left: 2px;
  }
`;

const ActionHistoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export default ActionHistoryModal;
